import styled, { keyframes } from "styled-components";
import { viewSizeCalculator } from "../../../utils";

const animloader = keyframes`
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
`;
export const LoadingSpinner = styled.div`
  width: ${({ width }) =>
    width ? viewSizeCalculator(width) : viewSizeCalculator(3)};

  height: ${({ height }) =>
    height ? viewSizeCalculator(height) : viewSizeCalculator(3)};
  display: inline-block;
  // position: relative;

  &::before,
  &::after {
    content: "";
    box-sizing: border-box;
    width: ${({ width }) =>
      width ? viewSizeCalculator(width) : viewSizeCalculator(3)};

    height: ${({ height }) =>
      height ? viewSizeCalculator(height) : viewSizeCalculator(3)};
    border-radius: 50%;
    border: ${({ border }) =>
      border
        ? `${viewSizeCalculator(border)} solid #000`
        : `${viewSizeCalculator(0.18)} solid #000`};
    position: absolute;
    /* left: 0; */
    top: 0;
    transform: scale(0);
    opacity: 1;
    animation: ${animloader} ${({ config }) => config?.speed || "2s"} linear
      infinite;
    animation-fill-mode: both;
  }

  &::after {
    animation-delay: ${({ config }) => config?.delay || "1s"};
  }
`;

export const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: ${({ config }) => (config?.top ? config?.top : "-10%")};
  /* left: 50%; */
  padding: ${({ config }) =>
    config?.wrapperPadding
      ? `${parseFloat(config?.wrapperPadding) / 16}rem`
      : "0"};
`;
